const rasaURL: string = "https://ksdata.theksquaregroup.com/chatbot/webhooks/rest/webhook";
// const rasaURL: string = "http://localhost:5005/webhooks/rest/webhook";

export const sendMessageToRasa = async (sender: string, message: string) => {
    try {
        const response = await fetch(
            rasaURL,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                credentials: "same-origin",
                body: JSON.stringify({
                    sender,
                    message,
                }),
            }
        );

        if (!response.ok) {
            throw new Error("Failed to fetch response from Rasa server");
        }

        const data = await response.json();

        if (data && data.length > 0) {
            console.log("Bot response: ", data);
            return data; 
        }
        throw new Error("No response from Rasa server");
    } catch (error) {
        console.error("Error sending message to Rasa:", error);
        return { message: "An error occurred while processing your request." };
    }
};

export function handleRasaResponse(response: any, addMessage: (msg: any) => void) {
    if (!Array.isArray(response) || response.length === 0) {
        console.error("Invalid or empty response array");
        return;
    }

    response.forEach((message: any) => {
        const { custom, text, buttons } = message;
        
        let messageText = text;
        let data = undefined;
        let checkboxes = undefined;
        let checkbox_slot = undefined
        let next_intent = undefined

        console.log("Custom data: ", custom);

        if (custom) {
            if (custom.data) {
                messageText = custom.data[0]?.message || custom.message || text;
                data = mapResponse(custom.data);
            } if (custom.message) {
                messageText = custom.message;
                console.log("Entro a checkboxes: ", custom);
                if (custom.type === "checkbox" && Array.isArray(custom.options)) {
                    checkboxes = custom.options;
                    checkbox_slot = custom.slot_name;
                    next_intent = custom.next_intent;
                }
            }
        }

        const botMessage = {
            sender: "bot",
            recipient_id: "user",
            text: messageText,
            message: messageText,
            buttons: buttons || "",
            data: data,
            checkboxes: checkboxes,
            checkbox_slot_name : checkbox_slot,
            next_intent: next_intent
        };

        console.log("Bot Message: ", botMessage);

        addMessage(botMessage);
    });
}

export function mergeButtonData(buttons: any){
    const pairedButtons = [];
    for (let i = 0; i < buttons.length; i += 2) {
        // Ensure there's a payload object following a title object
        if (buttons[i + 1] && buttons[i].title && buttons[i + 1].payload) {
            pairedButtons.push({
                title: buttons[i].title,
                payload: buttons[i + 1].payload
            });
        }
    }
    return pairedButtons;
}

export function mapResponse(custom: any) {
    const { action, provider, filters } = custom;
    const transformed = {
        text: custom.message || "",
        action: action || "",
        provider: provider || "",
        filters: filters || []
    };
    return transformed;
}

export function removeDuplicateFilters(data: any) {
    const { filters } = data.data;

    const uniqueFilters: { [key: string]: any } = {};

    for (const filter of filters) {
        const { column_name } = filter;
        uniqueFilters[column_name] = filter;
    }

    data.data.filters = Object.values(uniqueFilters);
    return data;
}

export const getProviderId = (providerName: string) => {
    if (providerName === "physician") return 1;
    if (providerName === "contract") return 2;
    if (providerName === "location") return 3;
    if (providerName === "taxonomy") return 4;
};
